module.exports = __webpack_public_path__ + "img/layout-bottom.d8773b8f.svg";